import labels from 'contexts/CruiseSearchContext/labels.json';
import { DYNAMIC_PRICE } from './Constants';

const getPerksInfo = perks => {
  const separator = labels?.targetedOfferPerkListLastDivider || ' ';
  const listPerks = Array.isArray(perks) ? perks : [];

  const listDescriptions = listPerks
    .filter(val => val.name != DYNAMIC_PRICE)
    .map(val => {
      const listDescription = Array.isArray(val.description)
        ? val.description
        : [];
      return listDescription.join(' ');
    });

  const descriptions = listDescriptions.filter(val => val !== '');

  const last = descriptions.slice(-1).pop() || '';
  const rest = descriptions.slice(0, -1);

  const descriptionSeparator =
    rest.length > 0 ? `${rest.join(', ')} ${separator} ${last}` : last;

  return {
    generalDescription: descriptions.join(' '),
    listDescriptions: descriptions,
    generalDescriptionSeparator: descriptionSeparator,
  };
};
export default getPerksInfo;
